import { render, staticRenderFns } from "./DialogTripView.vue?vue&type=template&id=16846712&scoped=true"
import script from "./DialogTripView.vue?vue&type=script&lang=js"
export * from "./DialogTripView.vue?vue&type=script&lang=js"
import style0 from "./DialogTripView.vue?vue&type=style&index=0&id=16846712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16846712",
  null
  
)

export default component.exports